<template>
  <div class="t-select-dropdown" :class="[{ 'is-multiple': $parent.multiple }, popperClass]" :style="{ minWidth: minWidth }">
    <slot></slot>
  </div>
</template>

<script>
  import Popper from '../../utils/popper/vue-popper'

  export default {
    name: 'TSelectDropdown',
    componentName: 'TSelectDropdown',
    mixins: [Popper],
    props: {
      placement: {
        default: 'bottom-start'
      },
      boundariesPadding: {
        default: 0
      },
      popperOptions: {
        default() {
          return {
            gpuAcceleration: false
          }
        }
      }
    },
    data() {
      return {
        minWidth: ''
      }
    },
    computed: {
      popperClass() {
        return this.$parent.popperClass
      }
    },
    watch: {
      '$parent.inputWidth' () {
        this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px'
      }
    },
    mounted() {
      this.referenceElm = this.$parent.$refs.reference.$el
      this.$parent.popperElm = this.popperElm = this.$el
      this.$on('updatePopper', () => {
        if(this.$parent.visible) this.updatePopper()
      })
      this.$on('destroyPopper', this.destroyPopper)
    }
  }
</script>


// WEBPACK FOOTER //
// packages/select/src/select-dropdown.vue